import {
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  styled,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { CheckoutIntent } from "../../types/CheckoutIntent";
import { PaymentMethodDisplay } from "./PaymentMethodDisplay";
import Stripe from "stripe";

const Container = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== "fullWidth",
})(({ theme, fullWidth }) => ({
  position: "relative",
  maxWidth: fullWidth ? "100%" : 353,
  width: "100%",
  marginBottom: 0,
}));

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

const StyledFormControlLabel = styled(FormControlLabel)<{
  selected?: boolean;
}>(({ theme, selected }) => ({
  margin: 0,
  padding: "0px 0",
  alignItems: "center",
  ".MuiTypography-root": {
    fontWeight: selected ? 700 : 500,
    fontSize: 14,
    color: theme.palette.primary.main,
  },
}));

const AddNewBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 12,
  cursor: "pointer",
  marginLeft: "10px",
  padding: "8px 0",
  fontSize: 14,
  color: theme.palette.primary.main,
  fontWeight: 500,
}));

const CheckoutPaymentSelectForm = ({
  items,
  selectedItem,
  fullWidth = false,
  value,
  onChange,
  onAddNewPaymentMethod,
  ...props
}: {
  items: CheckoutIntent["availablePaymentMethods"];
  selectedItem?: Stripe.PaymentMethod;
  fullWidth?: boolean;
  value: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: Stripe.PaymentMethod
  ) => void;
  onAddNewPaymentMethod: () => void;
}) => {
  return (
    <Container fullWidth={fullWidth}>
      <StyledRadioGroup
        value={value}
        onChange={(event, value) =>
          onChange(event, items?.find((i) => i.id === value)!)
        }
      >
        {items?.map((i) => (
          <StyledFormControlLabel
            key={i.id}
            value={i.id}
            control={<Radio color="primary" />}
            label={<PaymentMethodDisplay paymentMethod={i} />}
            selected={selectedItem?.id === i.id ? true : false}
          />
        ))}
        <AddNewBox
          onClick={onAddNewPaymentMethod}
          data-testid="add-new-payment-method"
        >
          <AddCircleOutlineIcon sx={{ fontSize: 24 }} />
          <Typography
            component="span"
            fontWeight={500}
            fontSize={14}
            color="primary.main"
          >
            Add new payment method
          </Typography>
        </AddNewBox>
      </StyledRadioGroup>
    </Container>
  );
};

export default CheckoutPaymentSelectForm;
